// src/components/TabSwitcher.jsx
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import InputForm from './InputForm';
import DemoView from './DemoView';

const TabSwitcher = () => {
  const location = useLocation();
  const restore = location.state?.restore;

  // 初期タブ: 復元モードがあればそれに合わせる（simple/detail→detailedへマップ）
  const initialTab =
    restore?.mode === 'simple' ? 'simple' : restore?.mode === 'detail' ? 'detailed' : 'detailed';

  const [activeTab, setActiveTab] = useState(initialTab);

  // 履歴ページから戻ってきた後に state が更新された場合にもタブを合わせる
  useEffect(() => {
    if (!restore) return;
    if (restore.mode === 'simple') setActiveTab('simple');
    if (restore.mode === 'detail') setActiveTab('detailed');
  }, [restore]);

  return (
    <div className="pt-6 mb-20">
      {/* 上下の余白調整（ヘッダー/フッター分） */}
      <div className="flex justify-center space-x-4 mb-6">
        <button
          type="button"
          className={`px-4 py-2 rounded ${
            activeTab === 'simple' ? 'bg-blue-700 text-white' : 'bg-gray-200 text-gray-800'
          }`}
          onClick={() => setActiveTab('simple')}
        >
          簡易
        </button>
        <button
          type="button"
          className={`px-4 py-2 rounded ${
            activeTab === 'detailed' ? 'bg-blue-700 text-white' : 'bg-gray-200 text-gray-800'
          }`}
          onClick={() => setActiveTab('detailed')}
        >
          詳細
        </button>
        <button
          type="button"
          className={`px-4 py-2 rounded ${
            activeTab === 'demo' ? 'bg-blue-700 text-white' : 'bg-gray-200 text-gray-800'
          }`}
          onClick={() => setActiveTab('demo')}
        >
          デモ
        </button>
      </div>

      <div>
        {activeTab === 'simple' && <InputForm mode="simple" /* restoreはlocationで受取 */ />}
        {activeTab === 'detailed' && <InputForm mode="detail" /* restoreはlocationで受取 */ />}
        {activeTab === 'demo' && <DemoView />}
      </div>
    </div>
  );
};

export default TabSwitcher;
